import axios from "axios";

export const getProductionOrderOee = async (machineId, itemNo, companyKey) => {

    //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const response = await axios.get(`api/OEEData/historicoee?machineId=${machineId}&itemNo=${itemNo}&companyKey=${companyKey}`);
    const data = response.data;
    return data;
}

export const getAllProductionOrderOee = async (companyKey) => {

    //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const response = await axios.get(`api/OEEData/historicoee-all?companyKey=${companyKey}`);
    const data = response.data;
    return data;
}

export const getProductionOrderHistoryByTool = async (toolId, companyKey) => {

    //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const response = await axios.get(`api/OEEData/historicoee-bytool?toolId=${toolId}&companyKey=${companyKey}`);
    const data = response.data;
    return data;
}


export const getProductionOrders = async (machineId, itemNo, companyKey) => {
    //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    const response = await axios.get(`api/productionorder?machineId=${machineId}&companyKey=${companyKey}`); //&itemNo=${itemNo}
    const data = response.data;
    return data;
}

export const getProductionOrderByOrderNo = async (productionOrderNo, operationNumber, companyKey) => {
    //console.log ("[Debug] fetchProductionOrder by orderno:", `api/productionorder/byorderno?productionOrderNo=${productionOrderNo}&operationNumber=${operationNumber}&companyKey=${companyKey}`);
    const response = await axios.get(`api/productionorder/byorderno?productionOrderNo=${productionOrderNo}&operationNumber=${operationNumber}&companyKey=${companyKey}`); //&itemNo=${itemNo}
    const data = response.data;
    return data;
}

export const setProductionOrderStatus = async (machineId, companyKey, prodOrder) => {
    // //console.log ("fetchProductionPlan:", `api/productionPlan?fromdate=${startDate}&todate=${endDate}&companyKey=${companyId}`);
    // const response = await axios.patch(`api/productionorder?machineId=${machineId}&companyKey=${companyKey}`, prodOrder); //&itemNo=${itemNo}
    // const data = response.data;
    // return data;

    return true;
}



export const getProducedByOrderNo = async (productionOrderNo, machineId, companyKey) => {
    //console.log ("[Debug] getProducedByOrderNo:", `api/OEEData/produced?productionOrderNumber=${productionOrderNo}&machineId=${machineId}&companyKey=${companyKey}`);

    productionOrderNo = productionOrderNo.trim()  === "#NA" ? "null" : productionOrderNo;
    const response = await axios.get(`api/OEEData/produced?productionOrderNumber=${productionOrderNo}&machineId=${machineId}&companyKey=${companyKey}`); 
    const data = response.data;
    console.log ("[Debug] getProducedByOrderNo DATA:", response.data);

    return data;
}




//ProductionOrderInSystem - Replaces ActiveProductionOrder endpoints with logic for managing production orders in the system

export const updateProductionOrderInSystem = async (productionOrder, statusid) => {
    const response = await axios.patch(`api/activeProductionOrder?statusId=${statusid}`, productionOrder);
    const data = response.data;
    return data;
}

export const reportProductionOrderInSystem = async (productionOrder, statusid, qty, sign) => {
    const response = await axios.patch(`api/ProductionOrderInSystem?statusId=${statusid}&qty=${qty}&userId=${sign}`, productionOrder);
    const data = response.data;
    return data;
}

export const createProductionOrderInSystem = async (productionOrder) => {
    const response = await axios.post(`api/ProductionOrderInSystem`, productionOrder);
    const data = response.data;
    return data;
}

export const pauseProductionOrderInSystem = async (productionOrders) => {
    const response = await axios.post(`api/ProductionOrderInSystem/pause`, productionOrders);
    const data = response.data;
    return data;
}

export const deleteProductionOrderInSystem = async (productionOrders) => {
    const response = await axios.post(`api/ProductionOrderInSystem/delete`, productionOrders);
    const data = response.data;
    return data;
}
